/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecurityQuestions } from '../../models/security-questions';

export interface SecurityQuestionPut$Params {
  id: number;
      body: SecurityQuestions
}

export function securityQuestionPut(http: HttpClient, rootUrl: string, params: SecurityQuestionPut$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityQuestions>> {
  const rb = new RequestBuilder(rootUrl, securityQuestionPut.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecurityQuestions>;
    })
  );
}

securityQuestionPut.PATH = '/api/SecurityQuestion/{id}';
